<div class="intervention-module">
  <h1 class="intervention-module__title">{{ selectedIntervention?.name }}</h1>
  <div
    cdkDropList
    [cdkDropListData]="interventionContentItems"
    (cdkDropListDropped)="dropItem($event)"
    fxLayout="column"
  >
    <div
      class="intervention-module__list"
      *ngFor="let contentItem of interventionContentItems; index as i"
      cdkDragLockAxis="y"
      cdkDrag
    >
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div
          (dblclick)="onOpenModulesTab(contentItem)"
          class="intervention-module__list-item"
          fxLayout="column"
          fxLayoutAlign="space-around start"
          fxFlex="90"
        >
          <label class="intervention-module__list-item--title">
            {{ contentItem?.module?.name }} <span *ngIf="contentItem?.triggers?.length > 0 && contentItem?.triggers[0]?.esmRules?.length > 0">(ESM)</span>
          </label>
        </div>
        <mat-icon
          *ngIf="contentItem?.triggers?.length || contentItem.module.removeAfter > 0"
          class="intervention-module__list-item--timer"
          color="primary"
          #tooltip="matTooltip"
          matTooltip="This is a timed module"
          matTooltipPosition="above"
          (click)="openTimingRulesDialog(contentItem)"
          >timer
        </mat-icon>
        <mat-icon
          *ngIf="!contentItem?.triggers?.length && !contentItem.module.removeAfter"
          class="intervention-module__list-item--timer"
          color="accent"
          #tooltip="matTooltip"
          matTooltip="This module is not timed"
          matTooltipPosition="above"
          (click)="openTimingRulesDialog(contentItem)"
          >timer_off
        </mat-icon>
        <mat-icon
          *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL)"
          class="intervention-module__list-item--delete"
          color="primary"
          #tooltip="matTooltip"
          matTooltip="Delete module from this intervention"
          matTooltipPosition="above"
          (click)="onDelete(contentItem)"
        >
          delete
        </mat-icon>
        <div class="bar" *ngIf="contentItem?.triggers?.length > 0 && contentItem?.triggers[0]?.esmRules?.length > 0" [ngStyle]="{ backgroundColor: this.colors[i] }"></div>
      </div>
    </div>
    <form [formGroup]="interventionModulesForm">
      <div *ngIf="selectModuleList?.length; else noModules">
        <div
          *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL)"
          class="intervention-module__content"
          fxLayout="row"
          fxLayoutAlign="space-around center"
        >
          <mat-form-field appearance="fill" fxFlex="70">
            <mat-select formControlName="moduleId" placeholder="- Select a module -">
              <mat-option *ngFor="let module of selectModuleList" [value]="module.id">
                {{ module?.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div appearance="fill" fxFlex="30" fxLayoutAlign="end center">
            <button
              (click)="onAddModule()"
              mat-button
              color="primary"
              type="button"
              class="intervention-module__content-button"
            >
              <span class="material-icons">add</span>
              {{ 'Add' | uppercase }}
            </button>
          </div>
        </div>
      </div>
    </form>
    <ng-template #noModules>
      <div
        class="intervention-module__content"
        fxLayout="column"
        fxLayoutAlign="space-around center"
        fxLayoutGap="20px"
        *ngIf="
          privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL) &&
          (privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL) ||
            privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.VIEW))
        "
      >
        <p *ngIf="!modules?.length" class="intervention-module__content-text">There are no modules in this study</p>
        <p *ngIf="!selectModuleList?.length && modules?.length" class="intervention-module__content-text">
          You've added all available modules
        </p>
        <button
          mat-button
          color="primary"
          *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL)"
          (click)="onOpenModulesTab()"
        >
          {{ 'Create new module' | uppercase }}
        </button>
      </div>
    </ng-template>
  </div>
</div>
